import { Workflow } from "../../../constants/Lookups";

export type AppointmentStatusTone =
  "planned" | "in-progress" | "completed" | "no-show" | "missed" | "neutral";

/** Colour family for an appointment status, shared by the hero pill and history rows. */
export const appointmentStatusTone = (
  stateName?: string | null
): AppointmentStatusTone => {
  switch (stateName) {
    case Workflow.APPOINTMENT_STATUS_PLANNED:
      return "planned";
    case Workflow.APPOINTMENT_STATUS_INPROGRESS:
      return "in-progress";
    case Workflow.APPOINTMENT_STATUS_COMPLETED:
      return "completed";
    case Workflow.APPOINTMENT_STATUS_NO_SHOW:
      return "no-show";
    case Workflow.APPOINTMENT_STATUS_CANCELED:
      return "missed";
    default:
      return "neutral";
  }
};
